import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MonedasComponent} from "../../monedas.component";
import {CurrencyService} from "../../../../../../core/services/parameters/currency.service";

@Component({
  selector: 'confirm-delete',
  templateUrl: './confirm-delete-currency.component.html',
  styleUrls: ['./confirm-delete-currency.component.scss']
})
export class ConfirmDeleteCurrencyComponent implements OnInit {

  id: number;

  constructor(
    public dialogRef: MatDialogRef<MonedasComponent>,
    private currencyService: CurrencyService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
  }

  ngOnInit(): void {
    this.id = this.data.id;
  }

  submit() {
    if (this.id !== undefined || this.id !== null)
      this.currencyService.deleteCurrency(this.id).subscribe(_res => {
        this.dialogRef.close(true);
      })
  }

  onNoClick(b: boolean) {
    this.dialogRef.close(b);
  }
}
